import React from 'react';
import parse, { domToReact, attributesToProps } from 'html-react-parser';

// Sanitized at build time. Keep headings/lists and the contact form's custom
// link renderer without introducing layout-changing wrapper elements.
export function CmsRichText({ field, fallback = null, components = {}, minimumHeadingLevel = 1 }) {
  if (!field?.html) return fallback;
  const options = {
    replace(node) {
      if (node.type === 'tag' && /^h[1-6]$/.test(node.name) && Number(node.name[1]) < minimumHeadingLevel) {
        return React.createElement(
          'h' + minimumHeadingLevel,
          attributesToProps(node.attribs),
          domToReact(node.children, options)
        );
      }
      if (node.type === 'tag' && node.name === 'a' && components.hyperlink) {
        const Hyperlink = components.hyperlink;
        return (
          <Hyperlink node={{ data: { url: node.attribs.href } }}>
            {domToReact(node.children, options)}
          </Hyperlink>
        );
      }
      return undefined;
    },
  };
  return <>{parse(field.html, options)}</>;
}

export function CmsText({ field }) {
  return <>{typeof field === 'string' ? field : field?.text || ''}</>;
}
